import { FEATURE_INBOX_MAX_VIEWER_USERS } from '../featureTypes'
import { selectPricingsById } from './selectPricingsById'

export const selectSupportsViewerAddonForPricingIds = (state, pricingIds) => {
  const pricingsById = selectPricingsById(state) || {}

  return (pricingIds || []).some(pricingId =>
    (pricingsById[pricingId]?.addonPricingIds || []).some(addonPricingId =>
      (pricingsById[addonPricingId]?.features || []).some(
        feature => feature?.key === FEATURE_INBOX_MAX_VIEWER_USERS
      )
    )
  )
}
